import { defaultHttpTimeoutMs } from '@core/constants';
import { getConfig } from '@superbet-group/web.lib.config';
import {
    createRestClient,
    processResponse,
} from '@superbet-group/web.lib.rest';
import { IResponse } from '@superbet-group/web.lib.utilities';
import { getCmsUrl } from '@core/services/cms/utils';
import { QuickLink } from '@shared/banners/QuickLink';
import { QuickLinkDto } from './QuickLinkDto';
import { mapQuickLink } from './QuickLinkMapper';
import { getPlatformParameter } from '../types/common';

export function createQuickLinksService() {
    const restClient = createRestClient(getConfig().cms?.baseUrl ?? '', defaultHttpTimeoutMs);
    const platform = getPlatformParameter();

    async function getQuickLinks(location: QuickLinkLocation): Promise<QuickLink[]> {
        const response = await processResponse(restClient.get<IResponse<QuickLinkDto[]>>(
            getCmsUrl({
                path: '/quick-links',
                queryParams: {
                    target: getConfig().countrySpecific.country,
                    locale: getConfig().appLocale.locale,
                    location,
                    platform,
                },
            }),
        ));
        const quickLinks = await Promise.all(response.data.map((quickLinkDto) => mapQuickLink(quickLinkDto)));
        return quickLinks.filter(
            (quickLink) =>
                quickLink.visible === true
                && quickLink.startDateMs < Date.now()
                && quickLink.endDateMs > Date.now(),
        );
    }

    return {
        getQuickLinks,
    };
}

export const QuickLinkLocation = {
    Games: 'games',
    Sport: 'sport',
} as const;
export type QuickLinkLocation = typeof QuickLinkLocation[keyof typeof QuickLinkLocation];
